import { Env } from "@stencil/core";
import { developmentConfig } from "./development-config";
import { productionConfig } from "./production-config";

const baseConfig = Env.dev ? developmentConfig : productionConfig;

export type EnvironmentConfig = typeof baseConfig;

const getConfigValue = (a, defaultIfNull = {}) =>
  a != null ? a : defaultIfNull;

const fullConfig: EnvironmentConfig = {
  apiUrls: getConfigValue((window as any).apiUrls, baseConfig.apiUrls),
  loginUrl: getConfigValue((window as any).loginUrl, baseConfig.loginUrl),
  contextPath: getConfigValue(
    (window as any).contextPath,
    baseConfig.contextPath
  ),
  navContextPath: getConfigValue(
    (window as any).navContextPath,
    baseConfig.navContextPath
  ),
  adyenPaymentConfig: getConfigValue(
    (window as any).adyenPaymentConfig,
    baseConfig.adyenPaymentConfig
  ),
  notificationConfig: getConfigValue(
    (window as any).notificationConfig,
    baseConfig.notificationConfig
  ),
  documentsConfig: getConfigValue(
    (window as any).documentsConfig,
    baseConfig.documentsConfig
  ),
  consentConfig: getConfigValue(
    (window as any).consentConfig,
    baseConfig.consentConfig
  ),
  wishlistConfig: getConfigValue(
    (window as any).wishlistConfig,
    baseConfig.wishlistConfig
  ),
  cartConfig: getConfigValue((window as any).cartConfig, baseConfig.cartConfig),
  inquiryConfig: getConfigValue(
    (window as any).inquiryConfig,
    baseConfig.inquiryConfig
  ),
  impersonateConfig: getConfigValue(
    (window as any).impersonateConfig,
    baseConfig.impersonateConfig
  ),
  pricesConfig: getConfigValue(
    (window as any).pricesConfig,
    baseConfig.pricesConfig
  ),
  orderHistoryConfig: getConfigValue(
    (window as any).orderHistoryConfig,
    baseConfig.orderHistoryConfig
  ),
  productComparisonConfig: getConfigValue(
    (window as any).productComparisonConfig,
    baseConfig.productComparisonConfig
  ),
  token: getConfigValue((window as any).token, baseConfig.token),
  translation: getConfigValue(
    (window as any).translations,
    baseConfig.translation
  ),
  deliveryDateFormat: getConfigValue(
    (window as any).deliveryDateFormat,
    baseConfig.deliveryDateFormat
  ),
  consents: getConfigValue((window as any).consents, baseConfig.consents),
  singleKeyIdConfig: getConfigValue(
    (window as any).singleKeyIdConfig,
    baseConfig.singleKeyIdConfig
  ),
  occConfig: getConfigValue((window as any).occConfig, baseConfig.occConfig),
  currentSessionLanguage: getConfigValue(
    (window as any).currentSessionLanguage,
    baseConfig.currentSessionLanguage
  ),
  currentSessionCurrency: getConfigValue(
    (window as any).currentSessionCurrency,
    baseConfig.currentSessionCurrency
  ),
  product: getConfigValue((window as any).product, baseConfig.product),
  ttEnergyLabelConfig: getConfigValue(
    (window as any).ttEnergyLabelConfig,
    baseConfig.ttEnergyLabelConfig
  ),
  /* TTRQ-52361 custom start */
  flyoutConfig: getConfigValue(
    (window as any).flyoutConfig,
    baseConfig.flyoutConfig
  ),
  /* TTRQ-52361 custom end */
  /* TTRQ-61778 custom start */
  pdpConfig: getConfigValue((window as any).pdpConfig, baseConfig.pdpConfig),
  /* TTRQ-61778 custom end */
  myPriceConfig: getConfigValue(
    (window as any).myPriceConfig,
    baseConfig.myPriceConfig
  ),
};

const config = window ? fullConfig : baseConfig;
export default config;
